import React from "react";
import { Link } from "react-router-dom";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";

import "./governance.scss";
import bi1 from "../../assets/img/code-of-conduct.jpg";
import bi2 from "../../assets/img/anti-bribery.jpg";
import bi3 from "../../assets/img/whistle-blower.jpg";
import bi4 from "../../assets/img/posh-policy.jpg";
import bi5 from "../../assets/img/supplier-code-of-conduct.jpg";

//import report4 from "../../assets/img/report4.png";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import goveranceImg1 from "../../assets/img/goverance_card01.svg";
import goveranceImg2 from "../../assets/img/goverance_card02.svg";
import zeroTolerance from "../../assets/img/zero-tolerance.svg";
import goveranceImg4 from "../../assets/img/goverance_card04.svg";
import highIntegrity from "../../assets/img/high-integrity.svg";
import transparency from "../../assets/img/transparency.svg";
import intoleranceNegligence from "../../assets/img/intolerance-negligence.svg";
import corporate_governance_img from "../../assets/img/corporate_governance_img.png";
import corporate_governance_banner from "../../assets/img/corporate-governance-banner.jpg";

import AyanaCodeofConduct from "../../assets/pdf/CorporateGoverence/Ayana_Code of Conduct_Website.pdf";
import AyanaAntiBriberyAntiCorruptionPolicy from "../../assets/pdf/CorporateGoverence/Ayana_ABAC_Website.pdf";
import AyanaWhistleBlowerPolicy from "../../assets/pdf/CorporateGoverence/Ayana_Whitle Blower Policy_Website.pdf";
import POSHPolicy from "../../assets/pdf/CorporateGoverence/POSHPolicy.pdf";
import CodeofConductforSuppliers from "../../assets/pdf/CorporateGoverence/CodeofConductforSuppliers.pdf";
import CSR_Policy_and_Committee_Composition from "../../assets/pdf/CorporateGoverence/CSR-Policy-and-Committee-Composition.pdf";

import csrPolicyCommitteeComposition from "../../assets/pdf/CorporateGoverence/csr-policy-committee-composition.png";

const Governance = () => {
  return (
    <div className="governance">
      <Navbar />
      <section
        className="pt-0 pb-0 position-relative banner_image_overlay"
        id={"goverence"}
      >
        <img
          src={corporate_governance_banner}
          alt=""
          className="img-fluid w-100"
        />
        <div className="breadcrumb_text">
          <h4 className="breadcrumb_title">Corporate governance</h4>
          <p className="breadcrumb_link">
            <Link to="/"> Home</Link> | Corporate Governance
          </p>
        </div>
      </section>

      <section>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-4 text-center">
              <img src={corporate_governance_img} alt="" className="w-50" />
            </div>
            <div className="col-md-8 vision_mission_block ps-4">
              <p>
                Ayana Renewable Power is committed to conducting its business
                with integrity and safeguarding the interest of stakeholders
                against any possible misconduct. To ensure this commitment, we
                have adopted specific policies that are applicable to everyone
                in our organisation and its subsidiaries.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="bg_grey ">
        <div className="container">
          <div className="row text-center">
            <center>
              <div className="title pt-5">
                <h4>YardSticks</h4>
              </div>
            </center>
          </div>
          <div className="card-container px-0 px-md-4 mt-3">
            <div className="row g-4 px-2">
              <div className="col-sm-6 col-md-6 col-xl-6">
                <div className="card">
                  <img className="cardImage" src={zeroTolerance} alt="" />
                  <p className="cardHeading">
                    {/* Zero tolerance <br /> approach */}
                    Zero tolerance towards <br /> negligence
                  </p>
                </div>
              </div>

              <div className="col-sm-6 col-md-6 col-xl-6">
                <div className="card">
                  <img className="cardImage" src={highIntegrity} alt="" />
                  <p className="cardHeading">
                    {/* High integrity */}
                    Zero tolerance towards bribing and <br /> corruption
                  </p>
                </div>
              </div>

              <div className="col-sm-6 col-md-6 col-xl-6  mt-4">
                <div className="card">
                  <img className="cardImage" src={transparency} alt="" />
                  <p className="cardHeading">
                    {/* Transparency */}
                    Transparency across all <br /> operations
                  </p>
                </div>
              </div>

              <div className="col-sm-6 col-md-6 col-xl-6 mt-4">
                <div className="card">
                  <img
                    className="cardImage"
                    src={intoleranceNegligence}
                    alt=""
                  />
                  <p className="cardHeading">
                    {/* Intolerance of negligence */}
                    Gold standards of governance and <br /> integrity
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="row text-center">
            <center>
              <div className="title pt-5">
                <h4>Outcomes</h4>
              </div>
            </center>
          </div>
          <div className="card-container px-0 px-md-4 mt-3">
            <div className="row g-4 px-2">
              <div className="col-12 col-sm-4 col-md-4 col-xl-4 mt-4">
                <div className="card">
                  <img className="cardImage" src={goveranceImg1} alt="" />
                  <p className="cardHeading">100% Compliance focused Company</p>
                </div>
              </div>

              <div className="col-12 col-sm-4 col-md-4 col-xl-4 mt-4">
                <div className="card">
                  <img className="cardImage" src={goveranceImg2} alt="" />
                  <p className="cardHeading">
                    Compliance with all applicable laws
                  </p>
                </div>
              </div>

              <div className="col-12 col-sm-4 col-md-4 col-xl-4 mt-4">
                <div className="card">
                  <img className="cardImage" src={goveranceImg4} alt="" />
                  <p className="cardHeading">
                    No adverse observations recorded during the last 6 years
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <center>
        <div className="title pt-5">
          <h4>Policies</h4>
        </div>
      </center>
      <section>
        <div className="container">
          <div className="row ">
            <div className="col-12 col-sm-6 col-md-4 col-xl-4 mb-3">
              <div className="bi_shadow_box bg-white p-3">
                <img src={bi1} className="w-100" alt="" />
                <div className="row mt-3">
                  <div className="col-9 col-sm-9 col-md-9 col-xl-9">
                    <p>Code of Conduct Policy</p>
                  </div>
                  <div className="col-3 col-sm-3 col-md-3 col-xl-3">
                    <a
                      className="pdf_link"
                      href={AyanaCodeofConduct}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <PictureAsPdfIcon />
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-sm-6 col-md-4 col-xl-4 mb-3">
              <div className="bi_shadow_box bg-white p-3">
                <img src={bi2} className="w-100" alt="" />
                <div className="row mt-3">
                  <div className="col-9 col-sm-9 col-md-9 col-xl-9">
                    <p>Anti-Bribery and Anti-Corruption Policy</p>
                  </div>
                  <div className="col-3 col-sm-3 col-md-3 col-xl-3">
                    <a
                      className="pdf_link"
                      href={AyanaAntiBriberyAntiCorruptionPolicy}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <PictureAsPdfIcon />
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-sm-6 col-md-4 col-xl-4 mb-3">
              <div className="bi_shadow_box bg-white p-3">
                <img src={bi3} className="w-100" alt="" />
                <div className="row mt-3">
                  <div className="col-9 col-sm-9 col-md-9 col-xl-9">
                    <p>Whistle Blower Policy</p>
                  </div>
                  <div className="col-3 col-sm-3 col-md-3 col-xl-3">
                    <a
                      className="pdf_link"
                      href={AyanaWhistleBlowerPolicy}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <PictureAsPdfIcon />
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-sm-6 col-md-4 col-xl-4 mb-3">
              <div className="bi_shadow_box bg-white p-3">
                <img src={bi4} className="w-100" alt="" />
                <div className="row mt-3">
                  <div className="col-9 col-sm-9 col-md-9 col-xl-9">
                    <p>POSH Policy</p>
                  </div>
                  <div className="col-3 col-sm-3 col-md-3 col-xl-3">
                    <a
                      className="pdf_link"
                      href={POSHPolicy}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <PictureAsPdfIcon />
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-sm-6 col-md-4 col-xl-4 mb-3">
              <div className="bi_shadow_box bg-white p-3">
                <img src={bi5} className="w-100" alt="" />
                <div className="row mt-3">
                  <div className="col-9 col-sm-9 col-md-9 col-xl-9">
                    <p>Supplier's code of conduct</p>
                  </div>
                  <div className="col-3 col-sm-3 col-md-3 col-xl-3">
                    <a
                      className="pdf_link"
                      href={CodeofConductforSuppliers}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <PictureAsPdfIcon />
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-sm-6 col-md-4 col-xl-4 mb-3">
              <div className="bi_shadow_box bg-white p-3">
                <img
                  src={csrPolicyCommitteeComposition}
                  className="w-100"
                  alt=""
                />
                <div className="row mt-3">
                  <div className="col-9 col-sm-9 col-md-9 col-xl-9">
                    <p>CSR Policy and committee composition</p>
                  </div>
                  <div className="col-3 col-sm-3 col-md-3 col-xl-3">
                    <a
                      className="pdf_link"
                      href={CSR_Policy_and_Committee_Composition}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <PictureAsPdfIcon />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Governance;
